import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';

const useDeleteTour = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (tourId) => toursApi.deleteTour(tourId),
    onSuccess: (_, tourId) => {
      toast.success('Wyjazd został usunięty');
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.byId(tourId),
      });
    },
    onError: (error: Error) => {
      toast.error('Wyjazdu nie można usunąć', {
        description: error.message,
      });
    },
  });
};

export default useDeleteTour;
